export default {
    apikey: "962d0ade"
}